// extracted by mini-css-extract-plugin
export default {"hdpFeebk":"index_hdpFeebk_w9fYw","login":"index_login_AbKVa"};